$(function () {
  // Select dropdowns (with freetext)
  $('select.js-minerva-form-select').each(function(){
    var $this = $(this),
        // Following might be [] because we don't always use radio buttons with a freetext choice
        $wrapper = $(this).closest('.js-minerva-form-select-wrapper'),
        $freetextContainer = $wrapper.find('.js-minerva-form-select-freetext'),
        $freetextInput = $wrapper.find('.js-minerva-form-select-freetext-content');

    $this.on('change', function () {
      var $option = $(this).find(':selected');
      if ($option.data('freetext') !== undefined) {
        $freetextContainer.slideDown();
      } else {
        $freetextContainer.slideUp();
      }
    });

    $freetextInput.on("change", function () {
      $wrapper.find("option[data-freetext]").val($(this).val());
    });
  });
});



// WEBPACK FOOTER //
// lib/js/minerva-form/select.js